<template>
  <footer class="thirdparty-footer" aria-label="IpromiseAfrica footer">
    <div class="thirdparty-footer-inner">
      <span class="thirdparty-footer-name">IpromiseAfrica</span>
    </div>
  </footer>
</template>

<script>
export default {
  name: "ThirdpartyFooter"
}
</script>

<style scoped>
.thirdparty-footer {
  width: 100%;
  background: var(--dashboard-bg);
  background-color: var(--background-color1); /* fallback if gradients are disabled */
  border-top: 1px solid var(--border-color-hover);
  padding: 22px 16px;
  margin-top: 24px;
}

.thirdparty-footer-inner {
  max-width: 1100px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

.thirdparty-footer-name {
  font-family: "Poppins", sans-serif;
  font-weight: 700;
  letter-spacing: 0.2px;
  color: var(--text-color1);
  text-align: center;
  position: relative;
  padding: 8px 14px;
  border-radius: 999px;
}

.thirdparty-footer-name::after {
  content: "";
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 2px;
  width: 56%;
  height: 2px;
  background: var(--border-color-hover);
  opacity: 0.85;
}

@media (max-width: 520px) {
  .thirdparty-footer {
    padding: 18px 12px;
  }

  .thirdparty-footer-name {
    font-size: 0.95rem;
    padding: 8px 12px;
  }
}
</style>

